"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// assets
//
const queryDefinitions_1 = require("queryDefinitions");
const tokenHeader_1 = require("tokenHeader");
const DateFormat_1 = require("components/general/utility/DateFormat");
//
// components
//
const ModalTable_1 = __importDefault(require("components/Dashboard/Tables/ModalTable"));
//
// styles
//
const StyledModalHeader_1 = require("components/Dashboard/Modals/StyledModalHeader");
const StyledModalSubHeader_1 = require("components/Dashboard/Modals/StyledModalSubHeader");
const StyledHeaderContainer_1 = require("components/Dashboard/Modals/StyledHeaderContainer");
const StyledModalCard_1 = require("components/Dashboard/Modals/StyledModalCard");
const StyledCardHeader_1 = require("components/Dashboard/Modals/StyledCardHeader");
const StyledTableContainer_1 = require("components/Dashboard/Modals/StyledTableContainer");
const StyledMultiOrdersContainer_1 = require("components/Dashboard/Modals/StyledMultiOrdersContainer");
const StyledOrderContainer_1 = require("components/Dashboard/Modals/StyledOrderContainer");
const StyledCloseIcon_1 = require("components/Dashboard/Modals/StyledCloseIcon");
const StyledIcon_1 = require("components/Dashboard/Modals/StyledIcon");
const CustomerModal = (props) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    const [authedLazyQuery, { data, renderWithLoadingAndErrorHandling }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_CUSTOMER_ORDERS);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '() => Promise<void>' is not assi... Remove this comment to see the full error message
    (0, react_1.useEffect)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if ((_a = props.customer) === null || _a === void 0 ? void 0 : _a.id) {
            // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
            authedLazyQuery({
                variables: { id: props.customer.id }
            });
        }
        if (props.display) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.removeAttribute('style');
        }
    }), [props.customer, props.display]);
    function toggleModal() {
        props.handleToggleModal();
    }
    function handleClick(event) {
        if (event.target.id === 'modal-root') {
            toggleModal();
        }
    }
    function renderOrders() {
        const ordersMap = [];
        if (!data) {
            return ordersMap;
        }
        data.customer.orders.edges.map((order) => {
            ordersMap.push(react_1.default.createElement(StyledOrderContainer_1.StyledOrderContainer, { key: order.node.number },
                react_1.default.createElement(StyledCardHeader_1.StyledCardHeader, { className: 'card-header', top: true },
                    react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, { half: true },
                        react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title order-number' }, order.node.number)),
                    react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, { half: true, right: true },
                        react_1.default.createElement(StyledModalSubHeader_1.StyledModalSubHeader, { className: 'card-header-title order-time' },
                            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-clock' }),
                            (0, DateFormat_1.hourlyFormat)(order.node.insertedAt)),
                        react_1.default.createElement(StyledModalSubHeader_1.StyledModalSubHeader, { className: 'card-header-title order-date', margin: true },
                            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-calendar' }),
                            (0, DateFormat_1.shortDateFormat)(order.node.insertedAt)))),
                react_1.default.createElement(StyledTableContainer_1.StyledTableContainer, { className: 'card-body' },
                    react_1.default.createElement(ModalTable_1.default, { data: order.node }))));
        });
        return ordersMap;
    }
    function renderSuccess() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledMultiOrdersContainer_1.StyledMultiOrdersContainer, null, renderOrders())));
    }
    function renderModal(content) {
        const customer = props.customer || {};
        return (react_1.default.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-container', role: 'document' },
            react_1.default.createElement("div", { className: 'modal-content' },
                react_1.default.createElement(StyledModalCard_1.StyledModalCard, { className: 'modal-card card', padding: true, style: { minHeight: '300px' } },
                    react_1.default.createElement(StyledCardHeader_1.StyledCardHeader, { className: 'card-header', height: '60px', top: true },
                        react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, null,
                            react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title customer-name' }, customer.firstName && customer.lastName
                                ? `${props.customer.firstName} ${props.customer.lastName}`
                                : '─')),
                        react_1.default.createElement("button", { "aria-label": 'Close', className: 'close', "data-dismiss": 'modal', onClick: toggleModal, type: 'button' },
                            react_1.default.createElement(StyledCloseIcon_1.StyledCloseIcon, { "aria-hidden": 'true' }, "\u00D7"))),
                    content))));
    }
    return (react_1.default.createElement("div", { "aria-hidden": 'true', className: 'modal fade show', id: 'modal-root', onClick: handleClick, role: 'dialog', style: {
            display: `${props.display ? 'block' : 'none'}`
        }, tabIndex: -1 }, renderWithLoadingAndErrorHandling({
        key: 'customer.orders',
        success: renderSuccess,
        container: renderModal // wrap loading indicator inside the modal
    })));
};
CustomerModal.propTypes = {
    customer: prop_types_1.default.shape({
        firstName: prop_types_1.default.string,
        email: prop_types_1.default.string,
        id: prop_types_1.default.string,
        insertedAt: prop_types_1.default.string,
        lastName: prop_types_1.default.string
    }),
    display: prop_types_1.default.bool,
    handleToggleModal: prop_types_1.default.func,
    modalFunc: prop_types_1.default.func
};
exports.default = CustomerModal;
